/* eslint-disable max-len */
import React from 'react';
function Careers() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M14,6V4h-4v2H14z M4,8v11h16V8H4z M20,6c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2L2,8c0-1.1,0.9-2,2-2h4V4 c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2v2H20z M16,11h-2v2h-2h-2v2H8H6v2h2h2h2h2h2h2v-2v-2v-2H16z" })));
}
export default Careers;
